var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputeStopped({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B8CE943C-AFA5-4107-A141-A5757ECBCC46") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(-56.000000, -324.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "STOPPED",
    transform: "translate(19.000000, 224.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/16x16/Compute/Paused",
    transform: "translate(37.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-box",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F7981C",
    cx: 17.8010108,
    cy: 17.8010108,
    r: 14.653371
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8725047,24.2830093 L24.8158992,18.9982761 C25.6136758,18.5282398 25.6162314,17.3696736 24.8158992,16.8996372 L15.8725047,11.6123485 C15.145839,11.1829788 14.0330011,11.5996448 14.0330011,12.6616927 L14.0330011,23.2336898 C14.0330011,24.1864662 15.0670861,24.7606629 15.8725047,24.2830093 Z",
    id: "\\uF04B",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputeStopped);
export default __webpack_public_path__ + "static/media/compute-stopped.429c3ddae151c2b726ad2ceff49f6130.svg";
export { ForwardRef as ReactComponent };